"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightMenuItemButton = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var tooltipAlignPoints = [{ align: "cl cr" }];
exports.DashboardInsightMenuItemButton = function (props) {
    var itemId = props.itemId, itemName = props.itemName, disabled = props.disabled, icon = props.icon, onClick = props.onClick, tooltip = props.tooltip, className = props.className, _a = props.submenu, submenu = _a === void 0 ? false : _a;
    // for JSX icons we need an extra gd-icon-wrapper class to align the icon and the text vertically
    return renderButtonWithTooltip(react_1.default.createElement(sdk_ui_kit_1.Item, { className: className, onClick: disabled ? undefined : onClick, disabled: disabled, subMenu: submenu },
        react_1.default.createElement("span", { className: classnames_1.default({ "gd-icon-wrapper": icon && typeof icon !== "string" }) },
            icon ? typeof icon === "string" ? react_1.default.createElement("i", { className: icon }) : icon : null,
            itemName)), itemId, disabled, tooltip);
};
function renderButtonWithTooltip(button, id, disabled, tooltip) {
    if (tooltip && disabled) {
        return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { className: "s-gd-bubble-trigger-options-menu-item" },
            button,
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary bubble-primary-" + id + " s-bubble-primary-" + id, alignPoints: tooltipAlignPoints }, tooltip)));
    }
    else {
        return button;
    }
}
//# sourceMappingURL=DashboardInsightMenuItemButton.js.map